import React from 'react';

import {
  Flex,
  FlexProps,
} from '@waglabs/flex-next';
// @ts-ignore
import { Portal } from '@waglabs/portal';

import { LoadingBoneSpinner } from './components/LoadingBoneSpinner';

export type LoadingBoneOverlayProps = FlexProps;
export const LoadingBoneOverlay = (props: LoadingBoneOverlayProps) => (
  <Portal>
    <Flex
      alignItems="center"
      bottom="0"
      justifyContent="center"
      left="0"
      position="fixed"
      right="0"
      top="0"
      zIndex={1400}
      {...props}
    >
      <LoadingBoneSpinner />
    </Flex>
  </Portal>
);
